// removed by extract-text-webpack-plugin
module.exports = {"icon":"_1tO1kCEo","text":"GSu2pQ_6","copy":"GDMLRgdi"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/hintr/hintr.styles.scss
// module id = 751
// module chunks = 0